module.exports = __webpack_public_path__ + "img/phasesEtudes.91effe67.png";